import { createLogger } from '@/lib/logger';
import { ProductsCarousel } from './products-carousel';

const logger = createLogger('skin-type-carousels');

document.addEventListener('DOMContentLoaded', () => {
  function hideDropdown() {
    const dropdownMenu = document.querySelector<HTMLDivElement>(
      '.skin-type-selector--dropdown-menu',
    );

    const wrapper = dropdownMenu?.closest('.skin-type-selector--dropdown-wrapper');

    if (wrapper) {
      wrapper.classList.remove('open');
    }

    if (dropdownMenu) {
      dropdownMenu.classList.remove('open');
    }
  }

  function lockScrolling() {
    // We only lock mobile because desktop uses a small dropdown, while mobile uses a full-screen popup
    document.body.classList.add('lock-scrolling', 'mobile-lock');
  }

  function unlockScrolling() {
    document.body.classList.remove('lock-scrolling', 'mobile-lock');
  }

  /**
   * Toggles the dropdown menu and locks the scrolling if the menu is opened.
   *
   * @returns {boolean} - true if the menu was opened as a result of this call, false otherwise
   */
  function toggleDropdown(): boolean {
    const dropdownMenu = document.querySelector<HTMLDivElement>(
      '.skin-type-selector--dropdown-menu',
    );

    if (dropdownMenu) {
      dropdownMenu.classList.toggle('open');
    }

    const wrapper = dropdownMenu?.closest('.skin-type-selector--dropdown-wrapper');

    if (wrapper) {
      wrapper.classList.toggle('open');
    }

    return dropdownMenu?.classList.contains('open') ?? false;
  }

  function showPanel(skinType: string) {
    const tab = document.querySelector(
      `.skin-type-carousels--skin-type[data-skin-type="${skinType}"]`,
    );

    if (tab) {
      const otherPanels = document.querySelectorAll(
        `.skin-type-carousels--skin-type:not([data-skin-type="${skinType}"])`,
      );

      otherPanels.forEach((panel) => {
        panel.classList.remove('active');
      });

      tab.classList.add('active');
    }
  }

  function setSelectedSkinType(type: string, displayName?: string) {
    if (!type) {
      logger.error('No skin type provided');
      return;
    }
    if (!displayName) {
      // Undo handleize
      displayName = type.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
    }

    const dropdownButton = document.querySelector('.skin-type-selector--dropdown-button');

    if (dropdownButton) {
      const buttonText = document.querySelector('.skin-type-selector--dropdown-button-text');

      if (buttonText) {
        buttonText.textContent = displayName;
      }
    }

    const input = document.querySelector<HTMLInputElement>('#skin_type');

    if (input) {
      input.value = type;
      input.dispatchEvent(new Event('change'));
    }

    const items = document.querySelectorAll<HTMLButtonElement>(
      '.skin-type-selector--dropdown-menu-item',
    );

    if (items) {
      items.forEach((item) => {
        item.classList.toggle('selected', item.getAttribute('data-skin-type') === type);
      });
    }

    ProductsCarousel.switchVisibleNavigation('skin-type-carousels', type);

    showPanel(type);
  }

  const dropdownButton = document.querySelector('.skin-type-selector--dropdown-button');

  if (dropdownButton) {
    dropdownButton.addEventListener('click', () => {
      const opened = toggleDropdown();

      if (opened) {
        lockScrolling();
      } else {
        unlockScrolling();
      }
    });
  }

  const closeBtn = document.querySelector<HTMLButtonElement>('.dropdown-menu--close-btn');

  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      hideDropdown();
      unlockScrolling();
    });
  }

  const bg = document.querySelector<HTMLDivElement>('.dropdown-menu--bg');

  if (bg) {
    bg.addEventListener('click', (e) => {
      e.stopPropagation();
      hideDropdown();
      unlockScrolling();
    });
  }

  const items = document.querySelectorAll<HTMLButtonElement>(
    '.skin-type-selector--dropdown-menu-item',
  );

  if (items) {
    items.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.stopPropagation();
        hideDropdown();
        unlockScrolling();

        const skinType = item.getAttribute('data-skin-type');

        if (skinType) {
          if (document.startViewTransition) {
            document.startViewTransition(() => {
              setSelectedSkinType(skinType);
            });
          } else {
            setSelectedSkinType(skinType);
          }
        }
      });
    });
  }
});
